import { MapPin } from 'lucide-react'
import { Link, useNavigate } from 'react-router'
import classNames from 'classnames'

import type { SubjectResponse } from '@/api/types/Subject'
import Avatar from '@/elements/Avatar'
import Button from '@/elements/Button'
import Label from '@/elements/Label'
import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import { getUserLocation } from '@/utils/location'

import './TalentCard.scss'

interface TalentCardProps {
  subject: SubjectResponse
  fromWatchdog?: boolean
  notificationCount?: SubjectResponse['alertsCount']
}

function TalentCard({
  subject,
  fromWatchdog,
  notificationCount
}: TalentCardProps) {
  const navigate = useNavigate()
  const subjectId = subject.id

  const handleProfileClick = (e: React.MouseEvent) => {
    e.preventDefault()
    navigate(`/profile/${subjectId}`)
  }

  return (
    <Link
      className={classNames('talent-card card', { 'from-watchdog': fromWatchdog })}
      to={`/watchdog/${subjectId}`}
    >
      <Flex inline wfull align='center' gap={3}>
        <Avatar
          name={subject.user.details.fullName}
          src={subject.user.assets?.PROFILE_PICTURE || undefined}
          notifications={notificationCount ? Number(notificationCount) : undefined}
          size='large'
        />
        <Flex gap={2} className='talent-card-info'>
          <Flex>
            <Text variant='h3' color='black'>{subject.user.details.fullName}</Text>
            <Label>{subject.group?.name || '--'}</Label>
          </Flex>
          <Flex inline>
            <MapPin size={14} />
            <Label small position='right'>{getUserLocation(subject.user.details)}</Label>
          </Flex>
        </Flex>
      </Flex>
      {fromWatchdog && (
        <Button
          variant='secondary'
          onClick={handleProfileClick}
        >
          View Profile
        </Button>
      )}
    </Link>
  )
}

export default TalentCard
